import React from "react";
import { Button, Header, Flex, Label } from "@fluentui/react-northstar";
import { Redirect } from "react-router-dom";
import translate from "../i18n/translate";
import { authContext } from "../auth";
import axios from "axios";
import {
  baseConsentUrl,
  ProvioningURL,
  ConsentccUrl,
  ConsentpresenceUrl,
  ConsentReportsUrl,
  ConsentAgentConsoleUrl,
  ConsentAgentConsoleUnifyUrl,
  ConsentAgentConsoleEuropeUrl,
} from "../urls";
const presenceAPp = "b49547c3-196e-4e6b-a4c0-a4deea391db0";
const contactCenterApp = "2ad91f01-bf93-4313-89f1-cb201229e7db";
const reportsApp = "2648d652-0325-425a-88a4-fd99068b32a8";
const agentConsoleApp = "f3ad2154-7e10-4730-a055-8852ced42d47";
const agentConsoleUnifyApp = "d42ccc26-e663-42bf-be39-4631345ad45e";
const agentConsoleEuropeApp = "13dc7c3d-b71b-4568-a68e-ac31df943617";
const consentUrl = baseConsentUrl;
const provioningURL = ProvioningURL;

class Consent extends React.PureComponent {
  render() {
    authContext.handleWindowCallback();
    let user = authContext.getCachedUser();
    let welcome = null;
    if (user) {
      welcome = "Welcome " + user.userName;
    } else {
      authContext.login();
    }
    let appId = null;
    if (this.props.location.pathname === "/Consentpresence") {
      appId = presenceAPp;
    }
    if (this.props.location.pathname === "/Consentcc") {
      appId = contactCenterApp;
    }
    if (this.props.location.pathname === "/ConsentReports") {
      appId = reportsApp;
    
    }
    if (this.props.location.pathname === "/ConsentAgentConsole") {
      appId = agentConsoleApp;
    }
    if (this.props.location.pathname === "/ConsentAgentConsoleUnify") {
      appId = agentConsoleUnifyApp;
    }
    if (this.props.location.pathname === "/ConsentAgentConsoleEurope") {
      appId = agentConsoleEuropeApp;
    }

    function getJsonFromUrl(url) {
      if (!url) url = location.search;
      var query = url.substr(1);
      var result = {};
      query.split("&").forEach(function(part) {
        var item = part.split("=");
        result[item[0]] = decodeURIComponent(item[1]);
      });
      return result;
    }
    let location = this.props.location;

    let params = getJsonFromUrl();

    if (
      params.admin_consent &&
      params.admin_consent === "True" &&
      params.tenant
    ) {
      let adminProfile = authContext.getCachedUser();
      ///{tenant}/{action}/{appId}/{adminId}
  
      axios.post(
        provioningURL +
          adminProfile.profile.tid +
          "/add/" +
          appId +
          "/" +
          adminProfile.profile.oid,
        adminProfile
      );
      return <Redirect to="/" />;
    } else { 
      return (
        <div className="Concent">
          <Flex hAlign="center" vAlign="center" gap="gap.large">
            <Header as="h5" content={welcome} color={"green"} />
          </Flex>
          <Label
            color="white"
            content="We need your consent for our Applications below to be able to deliver "
          />
          <Header
            style={{ marginLeft: "50px"  ,fontSize:"1.4em"}}
            as="h4"
            content={translate("COMMUN")}
          />
          <Header
            style={{ marginLeft: "100px" }}
            as="h3"
            content={translate(
              "HEEDIFY_REPORTS"
            )}
          />
          <Flex style={{ marginLeft: "100px" }} gap="gap.large">
            <Button
              primary
              content="Admin Consent"
              onClick={(e) => {
                e.preventDefault();
                window.location.href =
                  consentUrl +
                  reportsApp +
                  "&redirect_uri=" +
                  ConsentReportsUrl;
              }}
            />
          </Flex>
          <Header
            style={{ marginLeft: "100px" }}
            as="h3"
            content={translate("HEEDIFY_PRESENCE")}
          />
          <Flex style={{ marginLeft: "100px" }} gap="gap.large">
            <Button
              primary
              inline
              content="Admin Consent"
              onClick={(e) => {
                e.preventDefault();
                window.location.href =
                  consentUrl +
                  presenceAPp +
                  "&redirect_uri=" +
                  ConsentpresenceUrl;
              }}
            />
          </Flex>

          <Header
            style={{ marginLeft: "50px" ,fontSize:"1.4em" }}
            as="h4"
            content={translate("EXTEND")}
          />

          <Header
            as="h3"
            style={{ marginLeft: "100px" }}
            content={translate(
              "HEEDIFY_CALL_CENTER"
            )}
          />
          <Flex style={{ marginLeft: "100px" }} gap="gap.large">
            <Button
              primary
              content="Admin Consent"
              onClick={(e) => {
                e.preventDefault();
                window.location.href =
                  consentUrl +
                  contactCenterApp +
                  "&redirect_uri=" +
                  ConsentccUrl;
              }}
            />
          </Flex>
          <Header
            as="h3"
            style={{ marginLeft: "100px" }}
            content={translate("HEEDIFY_AGENT_CONSOLE")}
          />
          <Flex style={{ marginLeft: "100px" }} gap="gap.large">
            <Button
              primary
              content="Admin Consent"
              onClick={(e) => {
                e.preventDefault();
                window.location.href =
                  consentUrl +
                  agentConsoleApp +
                  "&redirect_uri=" +
                  ConsentAgentConsoleUrl;
              }}
            />
          </Flex>

          <Header
            style={{ marginLeft: "50px" ,fontSize:"1.4em" }}
            as="h4"
        content={translate("TPE")}
          />

          <Header
            as="h3"
            style={{ marginLeft: "100px" }}
            content={translate("HEEDIFY_AGENT_CONSOLE_UNIFY")}
          />
          <Flex style={{ marginLeft: "100px" }} gap="gap.large">
            <Button
              primary
              content="Admin Consent"
              onClick={(e) => {
                e.preventDefault();
                window.location.href =
                  consentUrl +
                  agentConsoleUnifyApp +
                  "&redirect_uri=" +
                  ConsentAgentConsoleUnifyUrl;
              }}
            />
          </Flex>
          <Header
            as="h3"
            style={{ marginLeft: "100px" }}
            content={translate("HEEDIFY_AGENT_CONSOLE_EUROPE")}
          />
          <Flex style={{ marginLeft: "100px" }} gap="gap.large">
            <Button
              primary
              content="Admin Consent"
              onClick={(e) => {
                e.preventDefault();
                window.location.href =
                  consentUrl +
                  agentConsoleEuropeApp +
                  "&redirect_uri=" +
                  ConsentAgentConsoleEuropeUrl;
              }}
            />
          </Flex>
        </div>
      );
    }
  }
}
export default Consent;
